import React from 'react';

import { IInputProps } from '@rbi-ctg/frontend';

import { Size } from './constants';
import Indicator, { HiddenInput, IndicatorContainer } from './indicator';

export interface ISelectionIndicatorProps extends Partial<IInputProps> {
  checked: boolean;
  defaultValue?: boolean;
  inputName?: string;
  size: Size;
  [key: string]: any;
  hasBackground?: boolean;
  hideInput?: boolean;
}

const SelectionIndicator = ({
  type = 'checkbox',
  checked,
  size,
  onChange,
  disabled,
  inputName,
  defaultValue,
  uiPattern,
  hasBackground,
  hideInput = false,
  ...rest
}: ISelectionIndicatorProps) => {
  return (
    <>
      <HiddenInput
        type={type}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        {...rest}
        name={inputName}
      />
      <IndicatorContainer
        checked={checked}
        uiPattern={uiPattern}
        hasBackground={hasBackground}
        type={type}
      >
        <Indicator
          checked={checked}
          defaultValue={defaultValue}
          disabled={disabled}
          size={size}
          uiPattern={uiPattern}
          hasBackground={hasBackground}
          type={type}
          hideInput={hideInput}
        />
      </IndicatorContainer>
    </>
  );
};

export default SelectionIndicator;
